export default {
  methods: {
    // 设置导航栏 activeBar
    setActiveBar(bar) {
      let payload = {
        key: 'activeBar',
        val: bar
      }
      this.$store.commit('updateStrData', payload)
    },

    // 存储token
    storeToken(token) {
      let payload = {
        key: 'token',
        val: token
      }
      this.$store.commit('updateStrData', payload)
      localStorage.setItem('WAITU_TOKEN', token)
    },

    // 存储图书馆token
    storeLibraryToken(token) {
      let payload = {
        key: 'libraryToken',
        val: token
      }
      this.$store.commit('updateStrData', payload)
      localStorage.setItem('WAITU_LIBRARY_TOKEN', token)
    },

    // 清除token
    removeToken() {
      localStorage.removeItem('WAITU_TOKEN')
      localStorage.removeItem('WAITU_LIBRARY_TOKEN')
    },

    // 检测用户是否已登录
    checkLogin() {
      let token = localStorage.getItem('WAITU_TOKEN')
      return (token == 'undefined' || !token) ? false : true
    },

    // 路由跳转
    goRouter(path) {
      this.$router.push({ path })
    },

    // 返回
    goBack() {
      this.$router.go(-1)
    }

  }
}


// WEBPACK FOOTER //
// ./src/mixin/index.js